import { type DocumentNode, gql } from '@apollo/client';

/**
 * Mutation variables for deleteAsset
 */
export interface DeleteAssetVariables {
  assetId: string;
}

/**
 * Response structure for deleteAsset mutation
 */
export interface DeleteAssetResponse {
  deleteAsset: {
    success: boolean;
  };
}

const deleteAssets: DocumentNode = gql`
  mutation deleteAsset($assetId: ID!) {
    deleteAsset(assetId: $assetId) {
      success
    }
  }
`;

export default deleteAssets;
